var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 469,
    height: 393,
    viewBox: "0 0 469 393",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385.951 189.692C385.674 187.917 384.012 186.702 382.233 186.979C380.459 187.256 379.245 188.924 379.522 190.7C379.99 193.733 380.582 203.232 377.306 207.054C376.597 207.88 375.74 208.376 374.664 208.573L374.962 190.481C375.005 187.853 372.89 185.699 370.259 185.699C367.617 185.699 365.491 187.88 365.555 190.524L366.408 224.858C365.278 224.677 364.389 224.181 363.654 223.323C360.378 219.501 360.974 210.002 361.438 206.969C361.715 205.194 360.5 203.525 358.727 203.248C356.947 202.971 355.286 204.186 355.009 205.961C354.774 207.454 352.894 220.759 358.705 227.55C360.703 229.885 363.409 231.213 366.567 231.415L366.935 246.362H374.035L374.552 215.135C377.641 214.895 380.283 213.579 382.249 211.281C388.066 204.49 386.185 191.19 385.951 189.692Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8388 218.803C82.663 217.673 81.603 216.894 80.4684 217.076C79.3392 217.252 78.5615 218.312 78.7426 219.448C79.0409 221.383 79.4191 227.438 77.331 229.875C76.8782 230.402 76.3349 230.717 75.6478 230.845L75.8396 219.309C75.8662 217.635 74.5185 216.26 72.8407 216.26C71.1574 216.26 69.8045 217.651 69.8418 219.336L70.3851 241.224C69.666 241.106 69.096 240.792 68.6326 240.248C66.5446 237.812 66.9228 231.756 67.2211 229.821C67.3968 228.691 66.6245 227.625 65.4952 227.449C64.3607 227.273 63.3007 228.046 63.1249 229.176C62.9757 230.13 61.7772 238.606 65.4792 242.94C66.7523 244.427 68.4781 245.275 70.4916 245.403L70.726 254.929H75.2536L75.5839 235.024C77.5494 234.869 79.2379 234.033 80.4897 232.567C84.1864 228.233 82.9879 219.752 82.8388 218.803Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.696 392.743C363.989 392.743 468.801 355.609 468.801 309.803C468.801 263.996 363.989 226.863 234.696 226.863C105.403 226.863 0.590332 263.996 0.590332 309.803C0.590332 355.609 105.403 392.743 234.696 392.743Z",
    fill: "url(#paint0_linear_305_2997)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M272.068 209.266C272.068 209.266 271.93 217.246 272.063 218.046C272.196 218.846 268.941 223.526 267.61 223.318C266.278 223.11 263.615 222.668 263.231 222.225C262.848 221.783 263.018 220.733 263.151 219.778C263.29 218.819 264.286 210.13 264.286 209.687C264.286 209.245 270.587 208.051 272.068 209.266Z",
    fill: "#FFD3BC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M266.906 217.587C265.239 218.488 264.307 221.228 264.067 221.26C263.833 221.292 263.391 221.228 263.391 220.956C263.391 220.685 263.46 219.773 263.157 219.773C262.853 219.773 262.512 221.26 262.448 223.43C262.379 225.599 261.612 230.765 262.448 231.421C262.975 231.831 267.796 234.368 267.929 234.704C268.062 235.045 267.828 237.412 268.233 237.785C268.638 238.159 269.586 239.07 270.332 239.107C271.077 239.139 275.371 239.582 277.405 239.107C279.435 238.633 282.007 237.652 282.077 237.38C282.146 237.108 281.571 231.351 280.926 230.642C280.282 229.933 275.647 223.563 275.275 222.987C274.902 222.412 274.63 221.026 274.63 220.21C274.63 219.4 273.895 217.625 272.526 217.198C271.099 216.756 268.158 216.91 266.906 217.587Z",
    fill: "url(#paint1_linear_305_2997)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.457 213.883C223.457 213.883 223.457 218.531 223.324 219.331C223.191 220.13 226.445 224.811 227.777 224.603C229.109 224.395 231.772 223.952 232.155 223.51C232.539 223.067 232.368 222.017 232.235 221.063C232.097 220.104 231.239 214.746 231.239 214.304C231.239 213.851 224.938 212.667 223.457 213.883Z",
    fill: "#FFD3BC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M227.745 111.315C225.859 118.17 222.296 141.663 222.296 153.081C222.296 164.499 221.156 193.61 221.156 198.029C221.156 202.454 220.682 213.43 221.822 214C222.962 214.57 225.63 216.287 229.247 215.716C232.864 215.146 233.817 212.859 233.913 210.764C234.009 208.669 234.867 193.615 235.724 187.805C236.582 181.995 239.629 170.784 241.626 163.577C243.624 156.365 248.29 141.871 249.526 141.924C250.761 141.977 258.474 173.737 259.113 175.539C259.758 177.341 260.978 202.912 261.058 205.06C261.138 207.209 261.058 209.272 262.405 210.146C263.753 211.02 267.886 213.168 270.028 213.323C272.174 213.483 273.602 210.066 273.996 209.032C274.396 207.998 275.099 173.791 274.843 164.409C274.587 155.027 275.333 137.526 274.896 131.822C274.465 126.118 273.069 113.89 272.18 111.315C271.301 108.741 227.745 111.315 227.745 111.315Z",
    fill: "#CECFD1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M214.434 31.6056C216.234 29.6066 224.624 20.1394 226.291 19.8035C227.958 19.4677 232.012 18.7374 232.912 17.8045C233.817 16.8717 237.637 4.86165 236.124 2.67607C234.611 0.490497 228.768 1.10886 226.999 4.82967C225.231 8.55048 225.316 10.4962 222.397 13.0656C219.478 15.6349 206.753 26.0457 205.57 27.0959C204.388 28.146 206.737 33.2581 208.596 34.143C210.46 35.0279 214.434 31.6056 214.434 31.6056Z",
    fill: "url(#paint2_linear_305_2997)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237.631 34.4895C233.343 35.3904 226.216 36.1527 223.867 36.915C221.513 37.6773 212.245 40.929 212.314 39.543C212.383 38.157 216.602 32.0694 215.84 31.4457C215.078 30.822 210.513 30.0597 209.752 29.0896C208.99 28.1194 207.951 25.8378 206.918 26.115C205.879 26.3922 193.852 37.6026 194.672 41.8992C196.611 52.0221 225.044 59.3944 225.694 63.8082C226.344 68.222 223.489 110.548 225.044 112.104C226.6 113.661 243.075 119.636 251.379 120.153C259.683 120.671 274.246 117.776 275.04 115.59C275.834 113.405 270.987 71.3511 271.551 71.3511C272.116 71.3511 272.27 84.5872 278.598 88.0095C282.774 90.2697 288.517 87.9402 289.614 86.6928C290.711 85.4454 285.688 67.8489 283.419 61.9105C281.144 55.9775 278.971 43.7116 273.831 39.3618C268.691 35.0119 261.436 35.7476 258.938 34.7294C256.44 33.7059 248.061 34.4415 245.946 34.2177C243.837 33.9938 237.631 34.4895 237.631 34.4895Z",
    fill: "url(#paint3_linear_305_2997)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M291.196 78.7395C291.196 78.7395 283.802 80.9783 283.227 81.746C282.652 82.5136 281.624 85.5947 283.227 86.8794C284.83 88.1641 286.588 89.1236 288.49 87.6417C290.391 86.1598 292.122 84.1714 293.22 83.9155C294.317 83.665 297.604 84.1341 298.983 83.5957C300.363 83.052 302.978 72.5879 301.924 71.9535C300.864 71.3192 291.196 78.7395 291.196 78.7395Z",
    fill: "url(#paint4_linear_305_2997)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M237.663 33.0769C235.277 32.5811 230.669 28.0714 230.248 23.4923C229.838 19.0306 226.557 6.4875 237.972 1.78052C248.684 -2.63328 259.705 1.90845 261.292 7.35107C262.773 12.4365 250.197 12.6658 245.589 15.9761C240.982 19.2864 240.667 21.4827 239.517 20.9603C238.361 20.4379 237.663 33.0769 237.663 33.0769Z",
    fill: "#E64D4E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M237.471 24.1374C237.322 26.179 236.806 36.0674 237.663 37.528C238.451 38.866 239.847 42.7521 245.318 42.5815C250.793 42.4109 254.341 36.931 254.644 36.2913C254.943 35.6516 254.304 27.7302 254.304 26.4029C254.304 25.0756 246.947 21.9518 243.996 22.0371C241.04 22.117 237.615 22.2183 237.471 24.1374Z",
    fill: "url(#paint5_linear_305_2997)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M237.972 24.1694C238.59 24.1534 237.86 27.9221 238.979 29.1535C240.097 30.3849 244.966 36.8084 250.117 36.1794C254.57 35.6356 253.931 31.7975 254.575 28.6311C255.156 25.7579 257.009 25.5127 257.659 18.0124C257.91 15.1125 259.284 10.5655 256.764 9.72856C254.245 8.88631 244.795 6.64743 242.446 9.72856C240.097 12.8097 239.874 20.198 238.643 19.2438C237.413 18.2896 234.84 13.6466 233.327 16.1627C231.82 18.6841 234.675 24.2653 237.972 24.1694Z",
    fill: "#F2DAD4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M277.746 62.5182L262.752 81.4901C261.974 82.4762 262.688 83.9262 263.945 83.9049L291.659 83.4358C292.117 83.4304 292.549 83.2065 292.826 82.8387L306.989 63.8988C307.66 63.0033 307.016 61.7239 305.897 61.7346L278.902 61.9585C278.449 61.9532 278.023 62.161 277.746 62.5182Z",
    fill: "url(#paint6_linear_305_2997)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M301.449 70.1571C299.99 70.3063 297.87 71.1273 297.87 71.8895C297.87 72.6518 299.569 72.8597 300.038 72.9344C300.507 73.0037 301.124 73.1529 300.949 73.3875C300.773 73.622 300.421 74.7947 299.484 74.5922C298.546 74.3843 294.44 74.3256 293.646 74.3256C292.852 74.3256 291.915 74.8854 291.856 75.4717C291.798 76.0581 291.622 76.1754 291.153 76.2074C290.684 76.2394 289.832 76.6765 289.832 77.4388C289.832 78.2011 291.718 78.8887 291.718 79.1606C291.718 79.4324 295.414 81.6873 296.139 82.1084C296.863 82.5296 298.216 83.5957 298.978 83.5957C299.74 83.5957 301.018 82.8707 301.114 81.8206C301.21 80.7704 302.717 80.0081 302.733 79.4911C302.754 78.974 302.259 78.5955 302.312 78.2704C302.371 77.9452 303.687 77.4867 303.687 76.6658C303.687 75.8449 303.17 74.7414 303.095 74.395C303.021 74.0538 302.712 73.3075 303.021 73.2115C303.324 73.1156 304.395 72.1241 304.203 71.2072C304.012 70.2957 302.126 70.0878 301.449 70.1571Z",
    fill: "#FFD3BC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_305_2997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.48 218.872C230.147 219.773 231.08 222.513 231.319 222.545C231.554 222.577 231.996 222.513 231.996 222.241C231.996 221.969 231.926 221.058 232.23 221.058C232.534 221.058 232.875 222.545 232.939 224.715C233.008 226.884 233.775 232.05 232.939 232.705C232.411 233.116 227.591 235.653 227.457 235.989C227.324 236.33 227.559 238.697 227.154 239.07C226.749 239.443 225.801 240.355 225.055 240.392C224.309 240.424 220.016 240.867 217.981 240.392C215.952 239.918 213.379 238.937 213.31 238.665C213.241 238.393 213.816 232.636 214.46 231.927C215.105 231.218 219.739 224.848 220.112 224.272C220.485 223.696 220.756 222.31 220.756 221.495C220.756 220.685 221.492 218.91 222.861 218.483C224.288 218.041 227.228 218.195 228.48 218.872Z",
    fill: "url(#paint7_linear_305_2997)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_305_2997",
    x: 209.304,
    y: 218.233,
    width: 28.022,
    height: 30.3771,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_305_2997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_305_2997",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_305_2997",
    x1: 234.698,
    y1: 189.269,
    x2: 234.698,
    y2: 319.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4764,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_305_2997",
    x1: 275.794,
    y1: 226.165,
    x2: 263.673,
    y2: 235.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9844,
    stopColor: "#575757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_305_2997",
    x1: 241.287,
    y1: 20.0873,
    x2: 218.372,
    y2: 17.5321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2DAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_305_2997",
    x1: 278.725,
    y1: 102.728,
    x2: 200.491,
    y2: 54.7107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#324774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#607AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_305_2997",
    x1: 292.462,
    y1: 82.1515,
    x2: 293.63,
    y2: 101.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7043,
    stopColor: "#F2DAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_305_2997",
    x1: 244.259,
    y1: 28.3187,
    x2: 251.845,
    y2: 44.1485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2BFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2DAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_305_2997",
    x1: 279.752,
    y1: 63.3897,
    x2: 292.958,
    y2: 87.6655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB9A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_305_2997",
    x1: 219.593,
    y1: 227.448,
    x2: 231.715,
    y2: 236.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9844,
    stopColor: "#575757"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.c8cc86b3c5783bfd8319462f6df7790c.svg";
export { ForwardRef as ReactComponent };